import React, { useEffect, useRef } from "react";

function Checkbox({
  name,
  value,
  error,
  onChange,
  children,
  title = null,
  ...rest
}) {
  const ref = useRef(null);
  useEffect(() => {
    ref.current.indeterminate = value === "mixed";
  }, [value]);
  return (
    <div className={"field"}>
      <div className={"control"}>
        <label className={"checkbox"} title={title}>
          <input
            id={name}
            ref={ref}
            name={name}
            type={"checkbox"}
            checked={value === true}
            onChange={({ currentTarget: me }) => {
              onChange(me.name, me.checked);
            }}
            {...rest}
          />
          {children}
        </label>
      </div>
      {error ? <p className={"help is-danger"}>{error}</p> : null}
    </div>
  );
}

export default Checkbox;
